
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.862 12c.05-.004.063-.003.113-.012a.834.834 0 00.448-.232l5-5c.034-.037.044-.046.075-.086a.834.834 0 000-1.007c-.031-.04-.04-.049-.075-.086l-5-5C1.386.543 1.377.533 1.337.502A.836.836 0 00.475.414.84.84 0 00.04 1.418c.029.09.073.176.13.252.03.04.04.049.075.086l4.411 4.41-4.41 4.412-.04.041c-.032.04-.04.048-.068.09a.836.836 0 00-.137.486.84.84 0 00.692.793c.05.009.063.008.113.012h.057z","fill":"#44474A"}})])
          )
        }
      }
    